
import { ColorSystem } from '../colors/color';

export type CardStyles = {
    borderRadius: string,
    
    variants:{
        outlined:CardVariantStyles,
        light:CardVariantStyles,
        lightGray:CardVariantStyles,
        attention:CardVariantStyles,
        none:CardVariantStyles
    }
}

export type CardVariantStyles = {
    // Only default is used by Card
    default: CardVariantStateStyles,
    // CardButton uses all states
    hover: CardVariantStateStyles,
    active: CardVariantStateStyles,
    disabled: CardVariantStateStyles
}

export type CardButtonVariantStyles = {
    
}

export type CardVariantStateStyles = {
    border:string,
    background:string,
    color:string
}

export function cardStyles(colors:ColorSystem): CardStyles 
{
    return {
        borderRadius: '4px',
        variants:{

            light: {
                default:{
                    border: `1px solid ${colors.card.light.default.border}`,
                    background: colors.card.light.default.background,
                    color: colors.card.light.default.color
                },
                hover:{
                    border: `1px solid ${colors.card.light.hover.border}`,
                    background: colors.card.light.hover.background,
                    color: colors.card.light.hover.color
                },
                active:{
                    border: `1px solid ${colors.card.light.active.border}`,
                    background: colors.card.light.active.background,
                    color: colors.card.light.active.color
                },
                disabled:{
                    border: `1px solid ${colors.card.light.disabled.border}`,
                    background: colors.card.light.disabled.background,
                    color: colors.card.light.disabled.color
                }
            },
            lightGray: {
                default:{
                    border: `1px solid ${colors.card.lightGray.default.border}`,
                    background: colors.card.lightGray.default.background,
                    color: colors.card.lightGray.default.color
                },
                hover:{
                    border: `1px solid ${colors.card.lightGray.hover.border}`,
                    background: colors.card.lightGray.hover.background,
                    color: colors.card.lightGray.hover.color
                },
                active:{
                    border: `1px solid ${colors.card.lightGray.active.border}`,
                    background: colors.card.lightGray.active.background,
                    color: colors.card.lightGray.active.color
                },
                disabled:{
                    border: `1px solid ${colors.card.lightGray.disabled.border}`,
                    background: colors.card.lightGray.disabled.background,
                    color: colors.card.lightGray.disabled.color
                }
            },
            outlined: {
                default:{
                    border: `1px solid ${colors.card.outlined.default.border}`,
                    background: colors.card.outlined.default.background,
                    color: colors.card.outlined.default.color
                },
                hover:{
                    border: `1px solid ${colors.card.outlined.hover.border}`,
                    background: colors.card.outlined.hover.background,
                    color: colors.card.outlined.hover.color
                },
                active:{
                    border: `1px solid ${colors.card.outlined.active.border}`,
                    background: colors.card.outlined.active.background,
                    color: colors.card.outlined.active.color
                },
                disabled:{
                    border: `1px solid ${colors.card.outlined.disabled.border}`,
                    background: colors.card.outlined.disabled.background,
                    color: colors.card.outlined.disabled.color
                }
            },
            attention: {
                default:{
                    border: `1px solid ${colors.card.attention.default.border}`,
                    background: colors.card.attention.default.background,
                    color: colors.card.attention.default.color
                },
                hover:{
                    border: `1px solid ${colors.card.attention.hover.border}`,
                    background: colors.card.attention.hover.background,
                    color: colors.card.attention.hover.color
                },
                active:{
                    border: `1px solid ${colors.card.attention.active.border}`,
                    background: colors.card.attention.active.background,
                    color: colors.card.attention.active.color
                },
                disabled:{
                    border: `1px solid ${colors.card.attention.disabled.border}`,
                    background: colors.card.attention.disabled.background,
                    color: colors.card.attention.disabled.color
                }
            },
            none: {
                default:{
                    border: `1px solid ${colors.card.none.default.border}`,
                    background: colors.card.none.default.background,
                    color: colors.card.none.default.color
                },
                hover:{
                    border: `1px solid ${colors.card.none.hover.border}`,
                    background: colors.card.none.hover.background,
                    color: colors.card.none.hover.color
                },
                active:{
                    border: `1px solid ${colors.card.none.active.border}`,
                    background: colors.card.none.active.background,
                    color: colors.card.none.active.color
                },
                disabled:{
                    border: `1px solid ${colors.card.none.disabled.border}`,
                    background: colors.card.none.disabled.background,
                    color: colors.card.none.disabled.color
                }
            }
        }
    };
}